import { BaseComponent } from "@/app/BaseComponent";

export class StepFormComponent<T = any> extends BaseComponent {
    submit(): Promise<T | undefined> {
        return Promise.resolve(undefined);
    }
}
